import Tracker from "@openreplay/tracker";
import type { OpenReplayConfig, SystemConfig } from "@/common/type-state";

let openReplayConfig: OpenReplayConfig | null = null;
let initRequested = false;
let tracker: Tracker | null = null;

const hasOpenReplayConfig = (
  config: OpenReplayConfig | null
): config is OpenReplayConfig => !!config && !!config.projectKey;

const initializeTracker = async () => {
  if (tracker || !hasOpenReplayConfig(openReplayConfig)) return;

  tracker = new Tracker({
    projectKey: openReplayConfig.projectKey,
    ingestPoint: openReplayConfig.ingestPoint,
    // OpenReplay refuses to record on a non-HTTPS origin (e.g. http://localhost) unless this is set.
    __DISABLE_SECURE_MODE: import.meta.env.DEV,
  });

  try {
    await tracker.start();
  } catch (err) {
    console.warn("[openreplay] Failed to start tracker", err);
  }
};

export const initTracker = async () => {
  initRequested = true;
  await initializeTracker();
};

export const setConfig = (config: SystemConfig) => {
  openReplayConfig = config.openReplay ?? null;

  if (initRequested) {
    void initializeTracker();
  }
};

export const getTracker = () => tracker;
